import {
  Button,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Modal,
  Show
} from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { LinkBroken01, XClose } from "untitledui-js-base";
import { EditModalContext } from "views/properties-id-units-id/types";

type EditConfirmModalProps = {
  opened: boolean;
  context?: EditModalContext;
  onClose: () => void;
  onChange: () => void;
};

export const EditConfirmModal = ({
  opened,
  onClose,
  onChange,
  context
}: EditConfirmModalProps) => {
  const dictionary = useUnitsPropertiesDictionary();
  return (
    <Modal
      zIndex={52}
      opened={opened}
      onClose={onClose}
      panelClassName="relative w-[366px] items-center flex flex-col p-6"
    >
      <div className="mb-4 rounded-full bg-alpha-40 p-4">
        <LinkBroken01 className="h-8 w-8 stroke-content-1000" />
      </div>

      <IconButton
        variant={IconButtonVariant.TEXT_BASE}
        size={IconButtonSize.SM}
        className="absolute right-6 cursor-pointer"
        onClick={onClose}
        Icon={XClose}
      />

      <p className="text-center text-xl font-bold px-4 mb-4">{context}</p>
      <Show if={context && context === EditModalContext.RentAmount}>
        <p className="text-content-500 font-normal text-center px-4 mb-4 text-base">
          Do you want to edit the rent amount for this {dictionary.unit}?
        </p>
      </Show>

      <div className="bg-danger-50 rounded-lg p-4">
        <p className="text-danger-600 text-sm font-medium">
          Manually edited fields will not be synchronized with values from PMS
          until you re-enable synchronization
        </p>
      </div>

      <div className="flex w-full gap-2.5 mt-4">
        <Button className="w-full" onClick={onClose}>
          Cancel
        </Button>

        <Button
          className="w-full"
          onClick={onChange}
          variant={ButtonVariant.PRIMARY}
        >
          Edit
        </Button>
      </div>
    </Modal>
  );
};
